import { takeEvery, fork, put, all, call } from 'redux-saga/effects';

import { customHeaders, adminAPIURL } from '../../../../../Containers/Config/index.js';
import { FORWARD_EMAIL_COMMUNICATION, FORWARD_EMAIL_COMMUNICATION_SUCCESS, FORWARD_EMAIL_COMMUNICATION_ERROR } from '../../actions.js';
import apiCall from '../../../apiCall.js';
import cogoToast from 'cogo-toast';

function* forwardEmailCommunication({ payload }) {
  try {
    const filteredHeaders = { ...customHeaders };
    delete filteredHeaders['X-Requested-By'];

    // const { clientId, programId, userId } = payload?.data;

    const response = yield call(apiCall, {
      url: `${adminAPIURL}/v2/ticket-system/tickets/email-forward`,
      method: 'POST',
      data: payload?.data,
      headers: {
        // Authorization: Constant?.CLIENT_TOKEN,
        ...filteredHeaders,
        // withCredentials: true
      }
    });

    if (response.status === 200 || response.status === 201) {
      cogoToast.success(`${response?.data?.message}`);

      yield put({
        type: FORWARD_EMAIL_COMMUNICATION_SUCCESS,
        payload: response?.data,
      });
    } else {
      cogoToast.error(`${response?.response?.data?.message}`);
      yield put({
        type: FORWARD_EMAIL_COMMUNICATION_ERROR,
        payload: response.data.message,
      });
    }
  } catch (error) {
    yield put({ type: FORWARD_EMAIL_COMMUNICATION_ERROR, payload: error });
  }
}

export function* watchForwardEmailCommunication() {
  yield takeEvery(FORWARD_EMAIL_COMMUNICATION, forwardEmailCommunication);
}

function* forwardEmailCommunicationSaga() {
  yield all([fork(watchForwardEmailCommunication)]);
}

export default forwardEmailCommunicationSaga;
